import { render, staticRenderFns } from "./TextFieldEditor.vue?vue&type=template&id=2be012cd&"
import script from "./TextFieldEditor.vue?vue&type=script&lang=ts&"
export * from "./TextFieldEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TextFieldEditor.vue?vue&type=style&index=0&id=2be012cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports